import React, { forwardRef, useImperativeHandle } from 'react';
import * as rsuite from 'rsuite';
import * as General from '../General/General';
import { trackPromise } from 'react-promise-tracker';
import axios from 'axios';


const Drp_SubLevel = forwardRef((props, ref) => {

    const toaster = rsuite.useToaster();

    const [List, setList] = React.useState([]);
    const [Id, setId] = React.useState(-1);
    const _Onchange = (value) => {
        props.onChange(value == null ? -1 : value, value == null ? "" : List.find(x => x.Id == value).Title)
        setId(value)
    }
    useImperativeHandle(ref, () => ({

        Bind(id) {
            var RequestOptions = {
                data: {
                    "Title": '',
                    "IsActive": 1,
                },
                url: General.ApiRoute() + "/Account_SubLevelGroup/GetAllForDRP",
                method: "post",
                withCredentials: true,

                headers: {
                    'ApiKey': General.APIKey(),
                    'Content-Type': 'application/json'
                }
            }


            trackPromise(
                axios(RequestOptions)
                    .then(function (result) {
                        var temp = [];
                        for (let index = 0; index < result.data.length; index++) {
                            temp.push({
                                Id: result.data[index].id,
                                Title: result.data[index].title
                            })
                            if (result.data[index].id == id) {
                                props.onChange(result.data[index].id, result.data[index].title)
                            }


                        }
                        setList(temp);
                        setId(id);


                    }).catch((error) => {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                    })
            )


        },

    }))



    return (
        <rsuite.SelectPicker


            data={List}
            valueKey="Id"
            labelKey="Title"
            className='w-100p'
            placeholder="انتخاب کنید..."
            value={Id}
            onChange={(value) => _Onchange(value)}

        />


    )
});

export default Drp_SubLevel;